<template lang="html">
    <div class="price-groups">
        <h2>Utilisateurs</h2>

        <data-table
            :headers="datatable.headers"
            :endpoint="datatable.endpoint"
            :toolbar="datatable.toolbar"
            :actions="datatable.actions"
            @rowClick="rowClick"
            storeId="users"
            ref="list"
            selectable
        >

            <template slot="items" slot-scope="props">
                <td>{{ props.item.first_name }}</td>
                <td class="text-xs-right">{{ props.item.last_name }}</td>
                <td class="text-xs-right">{{ props.item.email }}</td>
                <td class="text-xs-right">
                    <template v-if="props.item.role">
                        {{ props.item.role.label }}
                    </template>
                </td>
            </template>

        </data-table>
    </div>
</template>

<script>
    import DataTable    from '../../../../components/DataTable'
    import Create       from './Create'
    import Delete       from './Delete'

    export default {
        components: { DataTable },

        data() {
            return {
                datatable: {
                    toolbar: [
                        { icon: 'delete', callback: () => { this.$eventHub.$emit('open-modal', Delete) }, level:60 },
                    ],
                    actions: [
                        { text: 'Ajouter un utilisateur',   icon: 'add_circle', callback: () => { this.$eventHub.$emit('open-modal', Create) }, level:60 }
                    ],
                    headers: [
                       { text: 'Prénom',    sortable: true,     value: 'first_name', align: 'left' },
                       { text: 'Nom',       sortable: true,     value: 'last_name' },
                       { text: 'Email',     sortable: true,     value: 'email' },
                       { text: 'Role',      sortable: false,     value: 'role' }
                    ],
                    endpoint: {
                        base:       '/api/users',
                        embed:      'role'
                    }
                },
            }
        },

        methods: {
            rowClick(item) {
                //this.$eventHub.$emit('open-modal', Create, { user: item })
                this.$router.push({ name: 'admin-single-user', params: { id: item.id }})
            }
        },

        created() {
            this.$eventHub.$on('reload-list', () => {
                this.$refs.list.reload()
            })
        }
    }
</script>

<style lang="stylus" scoped>
    h2 { margin: 3rem 0 1rem }
</style>



// WEBPACK FOOTER //
// src/views/admin/users/list/List.vue